import { render, staticRenderFns } from "./clinicaljc.vue?vue&type=template&id=2ec8f2ba&scoped=true"
import script from "./clinicaljc.vue?vue&type=script&lang=js"
export * from "./clinicaljc.vue?vue&type=script&lang=js"
import style0 from "./clinicaljc.vue?vue&type=style&index=0&id=2ec8f2ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8f2ba",
  null
  
)

export default component.exports